import { Request } from "../Utils/useHttps";

export const Apis = {
  login: (data) => Request.post("/user/login", data),
  getUser: () => Request.get("/user"),
  updatePassword: (data) => Request.post("/user/update-password", data),
  // Category Apis
  addCategory: (data) => Request.post("/category", data),
  getCategories: () => Request.get("/category"),
  getCategoriesWithPagination: (offset = 0, limit = 10, params) =>
    Request.get(`/category?offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  getCategoriesToAddProducts: () =>
    Request.get("/category/admin-category-list"),
  updateCategoryStatus: (id, data) => Request.patch(`/category/status`, data),
  updateCategoryData: (id, data) =>
    Request.put(`/category/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getCategoryProducts: (id) => Request.get(`/product?categoryId=${id}`),
  getCategoryProductsWithPagination: (id, offset = 0, limit = 10, params) =>
    Request.get(`/product?categoryId=${id}&offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  deleteCategory: (id) => Request.delete(`/category/${id}`),
  updateCategoryPosition: (data) =>
    Request.put("/category/update-position", data),
  // Prodcuts Api
  getProducts: () => Request.get("/product"),
  getProductsWithPagination: (offset = 0, limit = 10, params) =>
    Request.get(`/product?offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  getProductNameList: () => Request.get("/product/name-id-list"),
  updateProductStatus: (data) => Request.patch(`/product/status`, data),
  getProductDetails: (id) => Request.get(`/product?id=${id}`),
  deletProduct: (id) => Request.delete(`/product/${id}`),
  addProduct: (data) =>
    Request.post("/product", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  showOnHomeScreen: (data) => Request.post("/product/change-order", data),
  getProductById: (id) => Request.get(`/product/`, { params: { id } }),
  updateProductPosition: (productId, newPosition) =>
    Request.put("/product/update-position", { productId, newPosition }),
  // Users Apis
  getAllUsers: (offset = 0, limit = 9) =>
    Request.get("/user/all", { params: { offset, limit } }),
  searchUsers: (params) => Request.get(`/user/all`, { params: params }),
  updateUSerStatus: (data) => Request.patch(`/user/update`, data),
  // Orders Apis
  getOrders: (params) =>
    Request.get("/orders", {
      params: params,
    }),

  updateOrderStatus: (orderId, body) =>
    Request.put(`/orders/update-status?orderId=${orderId}`, body),
  // Verify Payments
  getPayments: (queryParams) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return Request.get(`/orders/payment-screenshots?${queryString}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error("Error fetching payments:", error);
        throw error;
      });
  },

  updatePaymentStatus: (id, body) =>
    Request.put(`/orders/${id}/verify-payment`, body),

  // Reviews
  acceptReviews: (body) => Request.put(`/reviews`, body),
  getReviews: (params) => Request.get("/reviews", { params }),
  // Bank Accounts
  getBankAccounts: () => Request.get("/bank/bankAccountDetails"),
  addBankAccount: (data) => Request.post("/bank/bankAccountDetails", data),
  delteBankAccount: (id) => Request.delete(`/bank/bankAccountDetails/${id}`),
  updateBankAccount: (id, data) =>
    Request.put(`/bank/bankAccountDetails/${id}`, data),
  // Get Utm
  getUtmLinks: () => Request.get("/utm/all"),
  createUtm: (data) => Request.post("/utm/create", data),
  // URL should be in this format: /utm/update?id=123&status=true
  updateUtmStatus: (id, status) =>
    Request.patch(`/utm/update?id=${id}&status=${status}`),
  // Cities
  getCities: (offset = 0, limit = 9) =>
    Request.get("/cities", {
      params: { offset, limit },
    }),
  createCity: (data) => Request.post("/cities", data),
  updateCityStatus: (id, data) => Request.put(`/cities/${id}`, data),
  deleteCity: (id) => Request.delete(`/cities/${id}`),
  // Product Delivery Charges
  getProductsDeliveryCharges: (offset = 0, limit = 9) =>
    Request.get("/delivery-charges/product", {
      params: { offset, limit },
    }),
  addProductDeliveryCharges: (data) =>
    Request.post("/delivery-charges/product", data),
  deleteProductDeliveryCharges: (id) =>
    Request.delete(`/delivery-charges/product/${id}`),
  updateProductDeliveryCharges: (id, data) =>
    Request.put(`/delivery-charges/product/${id}`, data),
  // Terms and Conditions
  getTermsAndConditions: () => Request.get("/tac"),
  addTermsAndConditions: (data) => Request.post("/tac", data),
  updateTermsAndConditions: (id, data) => Request.put(`/tac${id}`, data),
  // Privacy Policy
  getPrivacyPolicy: () => Request.get("/pap/privacy-policy"),
  addPrivacyPolicy: (data) => Request.post("/pap/privacy-policy", data),
  updatePrivacyPolicy: (id, data) =>
    Request.put(`/pap/privacy-policy/${id}`, data),
  // Faq
  getFaq: () => Request.get("/frequently/faqs"),
  addFaq: (data) => Request.post("/frequently/faqs", data),
  updateFaq: (id, data) => Request.put(`/frequently/faqs/${id}`, data),
  // Discounted Products
  getDiscountedProducts: (id) =>
    Request.get(`/product/dicounted-products/${id}`),
  addDiscountedProducts: (data) => {
    return Request.post("/product/addDiscountTiers", data);
  },
  deleteDiscountedProducts: (id, discountTierId) =>
    Request.delete(`/product/remove/${id}/${discountTierId}`),

  // Order Details
  getOrderByOrderId: (orderId) => Request.get(`/orders?orderId=${orderId}`),

  // Dashboard Stats
  getStats: () => Request.get("/user/statistics"),
  // Pdf
  generatePdf: (data) => Request.post("/quotation", data),
  getAllProducts: () => Request.get("/quotation/products"),
  getVarinatByProductId: (productId) =>
    Request.get(`/quotation/product/${productId}/variants`),
  getColorsByVariantId: (variantId) =>
    Request.get(`/quotation/variant/${variantId}/colors`),
  getProductsForDeliveryCharges: () =>
    Request.get(`/product?offset=0&limit=1000`),
  addStock: (payload) => Request.post("/product/update-stock", payload),
  // Variant Stock Management
  updateVariantStock: (data) =>
    Request.post("/product/update-variant-stock", data),
  updateVariantStockDetails: (data) =>
    Request.put("/product/update-variant-stock-details", data),
  updateMultipleVariantStock: (data) =>
    Request.post("/product/update-multiple-variant-stock", data),
  addCarouselItems: (data) => Request.post("/product/change-order", data),
  getCarouselItems: () => Request.get("/product/carousel-products"),
  updateCarouselItems: (data) => Request.put("product/update-carousel", data),
  addFeaturedProduct: (data) => Request.post("/product/similar-products", data),
  getFeaturedProductsRelations: (id) =>
    Request.get(`/product/product-relation/${id}`),
  deleteLinkedProduct: (id) =>
    Request.delete(`/product/remove-similar-product/${id}`),
  updateSimilarProductPosition: (id, position) =>
    Request.put("/product/update-similar-product-position", { id, position }),
  getUnlinkedProducts: (id) =>
    Request.get(`/product/unlinked-feature-products/${id}`),
  updateProduct: (id, data) =>
    Request.put(`/product/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  addBanner: (data) =>
    Request.post("/banners/add", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  getBanners: () => Request.get("/banners/get"),

  updateBanner: (id, data) =>
    Request.put(`/banners/update/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  deleteBanner: (id) => Request.delete(`/banners/delete/${id}`),
  getPricing: () => Request.get("/pricing"),
  createPricing: (data) => Request.post("/pricing", data),
  updatePricing: (id, data) => Request.put(`/pricing/${id}`, data),
  deletePricing: (id) => Request.delete(`/pricing/${id}`),

  getPremiumPricing: () => Request.get("/premium-pricing"),
  createPremiumPricing: (data) => Request.post("/premium-pricing", data),
  updatePremiumPricing: (id, data) =>
    Request.put(`/premium-pricing/${id}`, data),
  deletePremiumPricing: (id) => Request.delete(`/premium-pricing/${id}`),

  addBrand: (data) =>
    Request.post("/brands", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getBrands: () => Request.get("/brands"),
  updateBrand: (id, data) =>
    Request.put(`/brands/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteBrand: (id) => Request.delete(`/brands/${id}`),

  // Tentative Cost Data
  getTentativeCost: () => Request.get("/tentative-cost"),
  addOrUpdateTentativeCost: (data) => Request.post("/tentative-cost", data),

  // Home Screen Management
  getHomeScreenData: () => Request.get("/home-screen"),

  updateHomeScreenData: (data) =>
    Request.put("/home-screen", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  postHomeScreenData: (data) =>
    Request.post("/home-screen", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteHomeScreenData: (id) => Request.delete(`/home-screen/${id}`),
  addHouseDesign: (data) =>
    Request.post("/house-design", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getHouseDesign: (offset = 0, limit = 10, params) =>
    Request.get(`/house-design?offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  getAllHouseDesignNames: () => Request.get(`/house-design/fetch/all`),
  updateHouseDesign: (id, data) =>
    Request.put(`/house-design/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteHouseDesign: (id) => Request.delete(`/house-design/${id}`),
  addHouseDesignToHomeScreen: (data) =>
    Request.post("/house-design/change-home-screen-status", data),
  addPopularHouseDesign: (data) =>
    Request.post("/house-design/add-popular-house-design", data),
  getHouseDesignById: (id) =>
    Request.get(`/house-design/singleHouseDesign?id=${id}`),
  getSimilarDesign: (id) => Request.get(`/house-design/similar/${id}`),
  addSimilarDesign: (data) => Request.post("/house-design/similar", data),
  removeSimilarDesign: (id) => Request.delete(`/house-design/similar/${id}`),
  updateSimilarHouseDesignPosition: (id, position) =>
    Request.put("/house-design/similar/update-position", { id, position }),
  getAllHouseDesign: (id) =>
    Request.get(`/house-designs/${encodeURIComponent(id)}`),
  getSimilarDesignExpectSelected: (id) =>
    Request.get(`/house-design/expect/${id}`),
  updateHouseDesignPosition: (data) =>
    Request.put("/house-design/update-position", data),

  addFrontElevation: (data) =>
    Request.post("/front-elevation", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  getFrontElevation: () => Request.get("/front-elevation"),
  getFrontElevationWithPagination: (offset = 0, limit = 10) =>
    Request.get(`/front-elevation?page=${offset}&limit=${limit}`),
  getFrontElevationById: (id) =>
    Request.get(`/front-elevation/single-front-elevation/${id}`),
  updateFrontElevation: (id, data) =>
    Request.put(`/front-elevation/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  deleteFrontElevation: (id) => Request.delete(`/front-elevation/${id}`),

  addPopularFrontElevation: (data) =>
    Request.post("/front-elevation/add-popular-front-elevation", data),

  getSimilarFrontElevation: (id) =>
    Request.get(`/front-elevation/similar/${id}`),

  addSimilarFrontElevation: (data) =>
    Request.post("/front-elevation/similar", data),

  removeSimilarFrontElevation: (id) =>
    Request.delete(`/front-elevation/similar/${id}`),

  updateSimilarFrontElevationPosition: (id, position) =>
    Request.put("/front-elevation/similar/update-position", { id, position }),

  getAllFrontElevation: (id) =>
    Request.get(
      `/front-elevation/all-front-elevation/${encodeURIComponent(id)}`,
    ),

  getSimilarFrontElevationExpectSelected: (id) =>
    Request.get(`/front-elevation/expect/${id}`),
  addCategoryBlog: (data) => Request.post("/blog-categories", data),
  getBlogCategories: (offset = 0, limit = 10, params) =>
    Request.get(`/blog-categories?offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  updateBlogCategory: (id, data) => Request.put(`/blog-categories/${id}`, data),
  deleteBlogCategory: (id) => Request.delete(`/blog-categories/${id}`),
  updateStatus: (id, data) =>
    Request.put(`/blog-categories/${id}/status`, data),
  updateBlogCategoryStatus: (id, status) =>
    Request.patch(`/blog-categories/${id}/status`, { status }),
  getBlogCategoryById: (id) => Request.get(`/blog-categories/${id}`),
  updateBlogCategoryPosition: (data) =>
    Request.put("/blog-categories/update-position", data),
  postBlog: (data) =>
    Request.post("/blog", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  updateBlog: (id, data) =>
    Request.put(`/blog/update/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  getBlogs: (params) => Request.get("/blog/get-all-blogs", { params }),
  addBlogToHomeScreen: (data) =>
    Request.post("/blog/change-home-screen-status", data),
  getBlogById: (id) => Request.get(`/blog/${id}`),
  addPopularBlog: (data) => Request.post("/blog/add-popular", data),
  addOnHeaderBlog: (data) => Request.post("/blog/add-header", data),
  deleteBlog: (id) => Request.delete(`/blog/${id}`),
  updateBlogPosition: (data) => Request.put("/blog/update-position", data),

  // House Plans
  getBuyPlans: () => Request.get("/buy-plans"),
  getBuyPlansById: (id) => Request.get(`/buy-plans/${id}`),
  addBuyPlan: (data) => Request.post("/buy-plans", data),
  deleteBuyPlan: (id) => Request.delete(`/buy-plans/${id}`),
  updateBuyPlan: (id, data) => Request.put(`/buy-plans/${id}`, data),

  // House Plan Association
  associateBuyPlanToHouseDesing: (body) =>
    Request.post("/buy-plans/buy-options-associtaion", body),
  getAssociardPlan: (houseDesignId) =>
    Request.get(
      `/buy-plans/buy-options-associtaion?house_design_id=${houseDesignId}`,
    ),
  updateHouseDesignPrimaryImage: (id) =>
    Request.put(`/house-design/primary-image/${id}`),
  getBuyPlanByHouseDesignId: (buyPlanId) =>
    Request.get(`buy-plans/buy-options-associtaion?buy_plan_id=${buyPlanId}`),
  getBuyPlanByHouseDesignIdData: (buyPlanId) =>
    Request.get(`/buy-plans/buy-options-associtaion/${buyPlanId}`),
  getExcludedHousePlans: (buyPlanId) =>
    Request.get(`buy-plans/excluded-houseDesing?buy_plan_id=${buyPlanId}`),
  updateBuyAssociatedPlan: (body) =>
    Request.put("buy-plans/update-buy-options-association", body),
  deleteBuyPlanFromHouseDesign: (id) =>
    Request.delete(`buy-plans/delete-options-association/${id}`),

  // Our Projects
  getOurProjects: (id) => Request.get(`our-projects/`, { params: { id } }),
  getAllProjectCategories: () => Request.get("our-projects/categories"),
  addProject: (data) =>
    Request.post("our-projects/", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateProject: (id, data) =>
    Request.put(`our-projects/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteProject: (id) => Request.delete(`our-projects/${id}`),
  getProjectById: (id) => Request.get(`our-projects/`, { params: { id } }),
  addProjectToHomeScreen: (data) =>
    Request.post("/our-projects/change-home-screen-status", data),
  getSimilarProjectExpectAdded: (id) =>
    Request.get(`our-projects/similar-expect-added/`, { params: { id } }),
  postSimilarProject: (data) =>
    Request.post(`our-projects/similar-projects/`, data),
  deleteSimilarProject: (id) =>
    Request.delete(`our-projects/similar-projects/`, { params: { id } }),
  updateSimilarProjectPosition: (id, position) =>
    Request.put("our-projects/similar-projects/update-position", {
      id,
      position,
    }),
  getAddedSimilarProject: (id) =>
    Request.get(`our-projects/similar-projects/`, { params: { id } }),
  getParentProjectCategories: () =>
    Request.get("our-projects/fetch-parent-category"),
  addSubCategory: (data) =>
    Request.post("our-projects/add-sub-category", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateSubCategory: (data) =>
    Request.put("our-projects/update-sub-category", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getSubCategories: (params) =>
    Request.get("our-projects/get-sub-categories", { params }),
  getOnTheBasisOfSubCategory: (id, params) =>
    Request.get(`our-projects/by-sub-category-id/${id}`, { params }),
  toggleProjectStatus: (id) => Request.put(`our-projects/toggle-status/${id}`),
  updateSubCategoryPosition: (id, position) =>
    Request.put("our-projects/update-category-position", { id, position }),
  updateProjectPosition: (data) =>
    Request.put("our-projects/update-position", data),

  // Interior Design Categories
  addInteriorDesignCategory: (data) =>
    Request.post("interior-design-categories", data),
  getInteriorDesignCategories: () => Request.get("interior-design-categories"),
  getInteriorDesignCategoriesWithPagination: (
    offset = 0,
    limit = 10,
    params = {},
  ) => {
    const queryParams = { offset, limit, ...params };
    return Request.get("interior-design-categories", { params: queryParams });
  },
  updateInteriorDesignCategory: (id, data) =>
    Request.put(`interior-design-categories/${id}`, data),
  deleteInteriorDesignCategory: (id) =>
    Request.delete(`interior-design-categories/${id}`),
  toggleInteriorDesignCategoryStatus: (id, status) =>
    Request.patch(`interior-design-categories/toggle-status/${id}`, { status }),
  updateInteriorDesignCategoryPosition: (data) =>
    Request.put("interior-design-categories/update-position", data),
  addInteriorDesignCategoryToHomeScreen: (data) =>
    Request.post("/interior-design-categories/change-home-screen-status", data),

  // Interior Design
  createInteriorDesign: (data) =>
    Request.post("interior-design/", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getInteriorDesign: (offset = 0, limit = 10, params = {}) => {
    const queryParams = { offset, limit, ...params };
    return Request.get("interior-design", { params: queryParams });
  },
  getInteriorDesignById: (id) =>
    Request.get(`interior-design/get-single-interior-design/${id}`),
  updateInteriorDesign: (id, data) =>
    Request.put(`interior-design/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteInteriorDesign: (id) => Request.delete(`interior-design/${id}`),
  getAllInteriorDesignCategories: () =>
    Request.get("interior-design-categories/all"),

  // Popular Interior Design APIs
  addPopularInteriorDesign: (data) =>
    Request.post("/interior-design/add-popular-interior-design", data),
  getAllInteriorDesigns: () => Request.get("/interior-design/on-home-screen"),
  getAllInteriorDesignNamesForPopularDesign: () =>
    Request.get("/interior-design/all-names"),
  addInteriorDesignToHomeScreen: (data) =>
    Request.post("/interior-design/change-home-screen-status", data),

  // Similar Interior Design APIs
  getSimilarInteriorDesign: (id) =>
    Request.get(`/interior-design/similar-design/${id}`),
  addSimilarInteriorDesign: (data) =>
    Request.post("/interior-design/similar", data),
  removeSimilarInteriorDesign: (id) =>
    Request.delete(`/interior-design/similar/${id}`),
  updateSimilarInteriorDesignPosition: (id, position) =>
    Request.put("/interior-design/similar/update-position", { id, position }),
  getSimilarInteriorDesignExpectSelected: (id) =>
    Request.get(`/interior-design/expect/${id}`),
  updateInteriorDesignPosition: (data) =>
    Request.put("/interior-design/update-position", data),

  // Zone CRUD operations
  getZone: (id) => Request.get(`/zone/${id}`),
  getAllZone: (offset = 0, limit = 10) =>
    Request.get("/zone", {
      params: { offset, limit },
    }),
  getZones: () => Request.get("/zone"),
  createZone: (data) => Request.post("/zone", data),
  updateZone: (id, data) => Request.put(`/zone/${id}`, data),
  deleteZone: (id) => Request.delete(`/zone/${id}`),

  // Services Categories (CRUD)
  addServiceCategory: (data) =>
    Request.post("/services-categories", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getServicesCategories: (offset = 0, limit = 10, params) =>
    Request.get(`/services-categories?offset=${offset}&limit=${limit}`, {
      params,
    }),
  // For dropdowns: fetch everything (no offset/limit).
  getServicesCategoriesForSelect: () =>
    Request.get("/services-categories"),
  updateServiceCategory: (id, data) =>
    Request.put(`/services-categories/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteServiceCategory: (id) => Request.delete(`/services-categories/${id}`),
  getServiceCategoryById: (id) => Request.get(`/services-categories/${id}`),

  // InStation Base Rate CRUD operations
  getAllInStation: (offset = 0, limit = 10) =>
    Request.get("/in-station-base-rate", {
      params: { offset, limit },
    }),
  getInStationBaseRate: (id) => Request.get(`/in-station-base-rate/${id}`),
  createInStationBaseRate: (data) =>
    Request.post("/in-station-base-rate", data),
  updateInStationBaseRate: (id, data) =>
    Request.put(`/in-station-base-rate/${id}`, data),
  deleteInStationBaseRate: (id) =>
    Request.delete(`/in-station-base-rate/${id}`),

  // OutStation Base Rate CRUD operations
  getAllOutStationBaseRates: (offset = 0, limit = 10) =>
    Request.get("/out-station-base-rate", {
      params: { offset, limit },
    }),
  getOutStationBaseRate: (id) => Request.get(`/out-station-base-rate/${id}`),
  createOutStationBaseRate: (data) =>
    Request.post("/out-station-base-rate", data),
  updateOutStationBaseRate: (id, data) =>
    Request.put(`/out-station-base-rate/${id}`, data),
  deleteOutStationBaseRate: (id) =>
    Request.delete(`/out-station-base-rate/${id}`),

  // InStation Zone CRUD operations
  getAllInStationZone: (offset = 0, limit = 10) =>
    Request.get("/in-station-zone", {
      params: { offset, limit },
    }),
  getInStationZone: (id) => Request.get(`/in-station-zone/${id}`),
  createInStationZone: (data) => Request.post("/in-station-zone", data),
  updateInStationZone: (id, data) =>
    Request.put(`/in-station-zone/${id}`, data),
  deleteInStationZone: (id) => Request.delete(`/in-station-zone/${id}`),
  getAllInStationZones: () => Request.get("/in-station-zone/all"),

  // Services
  getServices: (offset = 0, limit = 10, params) =>
    Request.get(`/services?offset=${offset}&limit=${limit}`, { params }),
  getServiceById: (id) => Request.get(`/services/${id}`),
  addService: (data) =>
    Request.post("/services", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateService: (id, data) =>
    Request.put(`/services/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteService: (id) => Request.delete(`/services/${id}`),

  // Contracts
  postContract: (data) =>
    Request.post("/contracts", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getContracts: () => Request.get(`/contracts`),
  getContractById: (id) => Request.get(`/contracts/${id}`),
  updateContract: (id, data) => Request.put(`/contracts/${id}`, data),
  deleteContract: (id) => Request.delete(`/contracts/${id}`),
  getUserContracts: (params) => Request.get(`/user-contracts`, { params }),
};
